<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <v-btn
      color="primary"
      slot="activator"
    >
      Bestehenden Gast hinzufügen
    </v-btn>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Gast hinzufügen</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-checkbox
            v-for="guest in guests"
            v-if="trainingGuests.filter((el) => el.guestId === guest.id).length === 0"
            :key="guest.id"
            :value="guest.id"
            v-model="selected"
            :label="`${guest.forename?guest.forename:''} ${guest.surname?guest.surname:''} <${guest.email}>`"
            hide-details
            class="ma-0"
          ></v-checkbox>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="cancel()">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="save()" :loading="loading">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'DialogInviteTrainingGuest',
    data() {
      return {
        dialog: false,
        guest: {},
        loading: false,
        selected: [],
      };
    },
    computed: {
      ...mapGetters({
        training: 'admin/trainings/one',
        newGuest: 'admin/guests/one',
        items: 'admin/guests/withCompany',
        trainingGuests: 'admin/trainings/guests',
      }),
      guests() {
        let localGuests = JSON.parse(JSON.stringify(this.items));
        localGuests.sort(this.compare);
        localGuests = localGuests.filter((el) => !!el.ceoId && el.ceoId !== '');
        localGuests = localGuests.sort((a, b) => {
          if (!a.forename) {
            return 5;
          }
          return (a.forename > b.forename) ? 1 : ((b.forename > a.forename) ? -1 : 0);
        });
        return localGuests;
      },
    },
    methods: {
      ...mapActions({
        createGuest: 'admin/guests/create',
        readGuests: 'admin/guests/read',
        addGuest: 'admin/trainings/addGuests',
        readTrainingGuests: 'admin/trainings/readGuests',
      }),
      save() {
        this.loading = true;
        const promises = [];
        this.selected.forEach((el) => {
          // eslint-disable-next-line max-len
          promises.push(this.addGuest({id: this.training.id, guests: [el]}));
        });
        Promise.all(promises).then(() => this.readTrainingGuests({id: this.training.id}))
          .then(() => {
            this.loading = false;
            this.dialog = false;
          });
      },
      cancel() {
        this.dialog = false;
        this.selected = [];
      },
    },
    watch: {
      async dialog() {
        this.loading = true;
        await this.readGuests();
        await this.readTrainingGuests({id: this.training.id});
        this.loading = false;
      },
    },
  };
</script>

<style scoped>

</style>
